import axios from 'axios';
import { getToken, logout } from 'data/users';
import swal from 'sweetalert';

export const CoreRequest = axios.create({
    baseURL: process.env.REACT_APP_CORE_API
});


CoreRequest.interceptors.request.use(
    config => {
        const token = getToken();
        config.headers.Authorization = token ? 'Bearer ' + token : '';
        return config;
    },
    err => {
        Promise.reject(err);
    }
);

CoreRequest.interceptors.response.use(
    response => response,
    error => {

        const { response: {status, data}} = error;

        /** usuario no autorizado */
        if (status === 401) {
        swal('Afinidata', 'Credenciales inválidas', 'error')
        .then( () => {
            logout();
            window.location.href = '/';
        });
        }

        if (status === 403) {
        const isTokenError = data?.data?.errors?.some((e: string) => e.includes('Token error'));
        if (isTokenError) {
            /** token expirado o inválido */
            swal('Afinidata', 'Tu sesión expiró', 'error')
            .then( () => {
                logout();
                window.location.href = '/';
            });
        } else {
            /** usuario sin permisos */
            swal('Afinidata', 'Usuario no tiene permisos', 'error')
            .then( () => {
                window.location.href = '/admin/dashboard';
            });
        }
        }

        return Promise.reject(error);
    }
    );